import * as React from "react";
import * as Media from "react-media";
import Helmet from "react-helmet";
import OnClient from "../components/OnClient";
import Header from "../components/Header";

import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import muiTheme from "../utils/mui_theme";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";

import Footer from "../components/Footer/Footer";

import * as algoliasearch from 'algoliasearch'

import "../styles/devportal.scss";

require("bootstrap/dist/css/bootstrap-grid.css");

import * as injectTapEventPlugin from "react-tap-event-plugin";

injectTapEventPlugin();

interface IndexLayoutProps {
	productionApiUrl: string;
	productionApiWsUrl: string;
	location: Location;
	data: any,
	children(): any; // page content
}


class IndexLayout extends React.Component<IndexLayoutProps, any> {
	state = {
		isInfoModalOpen: false,
	};

	handleOpenInfoModal() {
		this.setState({isInfoModalOpen: true});
	}

	handleCloseInfoModal() {
		this.setState({isInfoModalOpen: false});
	}

	render() {
		const {children, location, data} = this.props;

		return (
			<MuiThemeProvider muiTheme={muiTheme}>
				<OnClient>
					{hasRendered => (
						<div
							style={{
								visibility: hasRendered ? "visible" : "hidden",
								display: "flex",
								flexDirection: "column",
								height: "100vh"
							}}
						>
							<Helmet
								title="Vatom Developer Platform"
								meta={[
									{
										name: "description",
										content: "Vatom Developer Platform: Imagination to Revenue",
									},
									{
										name: "keywords",
										content:
											"vtaom, blockv, vee, developer portal, developer platform, sdk, api, developers, samples, examples, endpoint",
									},
								]}
							/>

							<Header locationPath={location.pathname} data={data}/>

							<Media query={{ maxWidth: 768 }}>
								{isMobile => (
									<div
										style={{
											marginTop: "73px",
											marginBottom: "0",
										}}
									>
										{children()}
									</div>
								)}
							</Media>

							{/* note: this is a bad solution...
							 we shouldn't have to switch the Footer styles so much for different routes...
							 figure out how to implement the pages in a standard way that allows the footer to be standard, or put a different one on each page */}
							<Footer onInfoClick={this.handleOpenInfoModal.bind(this)} />

							<Dialog
								title="Development Info"
								actions={
									<>
										<FlatButton
											label="Close"
											primary={true}
											keyboardFocused={true}
											onClick={this.handleCloseInfoModal.bind(this)}
										/>
									</>
								}
								modal={false}
								open={this.state.isInfoModalOpen}
								onRequestClose={this.handleCloseInfoModal.bind(this)}
							>
								<p>
									The following information is helpful for our development team to maintain and
									improve this page. If it's not relevant to you, feel free to click the "Close"
									button.
								</p>

								<p>
									Build #{process.env.GATSBY_BUILD_NUMBER}
									<br />
									Git Hash: {process.env.GATSBY_GH_SHA1}
								</p>
								<p style={{ marginBottom: 0 }}>
									Enabled Flags:
									<br />
									<br />
									{/* {Object.entries(process.env)
										.filter(entry => entry[0].indexOf("FEATURE_") === 0 && entry[1] === "true")
										.map(entry => (
											<span key={entry[0]} style={{ display: "block" }}>
												{entry[0]}
											</span>
										))} */}
								</p>
							</Dialog>
						</div>
					)}
				</OnClient>
			</MuiThemeProvider>
		);
	}
}

interface GraphQLWrapperProps {
	location: Location;
	data: {
		pages: {
			edges: Array<{
				node: {
					id: string;
					frontmatter: {
						title: string;
						path: string;
						category: string;
						platform: string;
						group: string;
					};
					htmlAst: any;
				};
			}>;
		};
	};

	children(): any; // page content
}

const GraphQLWrapper = (props: GraphQLWrapperProps) => {
	const location = props.location;
	return (
		<IndexLayout
			productionApiUrl={process.env.BLOCKV_API_URL}
			productionApiWsUrl={process.env.BLOCKV_API_WS_URL}
			location={location}
			children={props.children}
			data={props.data}
		/>
	);
};

export default GraphQLWrapper;

export const pageQuery = graphql`
query AlgoliQuery{
	pages: allMarkdownRemark(
	  filter: {
		fileAbsolutePath: { regex: "/docs/documentation/" },
	  }
	) {
	  edges {
		node {
		  id
		  frontmatter {
			path
			title
			category
			platform
			group
		  }
		  htmlAst
		  excerpt(pruneLength: 5000)
		}
	  }
	}
}
`;


// WEBPACK FOOTER //
// ./src/layouts/index.tsx